var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5263 5.93236C11.7972 5.68921 12.2027 5.68921 12.4736 5.93236L16.1308 9.21465C16.4255 9.4792 16.4563 9.93366 16.2075 10.2374C15.9505 10.551 15.4883 10.5912 15.1835 10.3176L12 7.46045L8.8165 10.3176C8.51165 10.5912 8.04946 10.551 7.79249 10.2374C7.54366 9.93366 7.57442 9.4792 7.86918 9.21465L11.5263 5.93236Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5263 18.0676C11.7972 18.3108 12.2027 18.3108 12.4736 18.0676L16.1308 14.7854C16.4255 14.5208 16.4563 14.0663 16.2075 13.7626C15.9505 13.449 15.4883 13.4088 15.1835 13.6824L12 16.5395L8.8165 13.6824C8.51165 13.4088 8.04946 13.449 7.79249 13.7626C7.54366 14.0663 7.57442 14.5208 7.86918 14.7854L11.5263 18.0676Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortControl);
export default __webpack_public_path__ + "static/media/SortControl.4f728bf754f5c052acb59f0642aa9e95.svg";
export { ForwardRef as ReactComponent };